const translations = {
  dashboardTabs: {
    ariaLabel: 'Dashboard sections',
    qa: 'Q&A',
    users: 'Users',
    credits: 'Credits',
  },
  common: {
    accessDenied: 'Access denied',
    loading: 'Loading data',
    back: 'Back',
    cancel: 'Cancel',
    close: 'Close modal',
    delete: 'Delete',
    edit: 'Edit',
    next: 'Next',
    reset: 'Reset',
    retry: 'Retry',
    saving: 'Saving...',
    search: 'Search',
  },
  userManagement: {
    navigation: {
      users: 'Users',
      manageUsers: 'Manage users',
    },
    manageTitle: 'Manage users',
    table: {
      email: 'Email Address',
      userName: 'Username',
      organisationName: 'Organisation Name',
      sso: 'SSO/No SSO',
      filterName: 'Filter by user name',
      filterEmail: 'Filter by user email',
      loading: 'Loading users...',
      sectionTitle: 'Organisation-scoped users',
      resultCount: '{{count}} total',
      empty: 'There are no active users in the current organisation.',
      noResults: 'No results found for the current organisation.',
      loadFailed: "Couldn't load users for the current organisation.",
    },
    add: {
      title: 'Add user',
      success: 'User added.',
      failure: 'User could not be added. Please try again.',
    },
    edit: {
      title: 'Edit User {{email}}',
      save: 'Save User',
      success: 'User saved.',
      failure: 'User could not be saved. Please try again.',
    },
    delete: {
      title: 'Delete user',
      bodyPrefix: 'Delete login access for',
      bodySuffix: 'from {{organisation}}? This action is irreversible.',
      pending: 'Deleting...',
      success: 'User deleted.',
      failure: 'User could not be deleted. Please try again.',
      multiTitle: 'CEADE handling required',
      multiBody: "belongs to more than one organisation, so they cannot be deleted here. Please email the CEADE admin team and they'll take care of this deletion for you.",
    },
    form: {
      backToUsers: 'Back to users',
      userDetails: 'User details',
      organisationKnowledgeBases: 'Organisation knowledge bases',
      firstName: 'First name',
      firstNamePlaceholder: 'Enter name',
      surname: 'Surname',
      surnamePlaceholder: 'Enter surname',
      displayName: 'Display name',
      displayNamePlaceholder: 'Enter display name',
      displayNameRequired: 'Display name is required.',
      email: 'Email',
      emailPlaceholder: 'Enter email',
      emailRequired: 'Email is required.',
      emailInvalid: 'Enter a valid email address.',
      phone: 'Phone number',
      phonePlaceholder: 'Enter phone number',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      passwordRequired: 'Password is required.',
      addPasswordHelp: 'Enter an initial password for the new user. A password is required even when Force change password on next login is selected.',
      passwordInvalid: 'Password must have 8–256 chars and contain at least 3 of: lowercase, uppercase, number, special char',
      newPassword: 'New password',
      passwordHelp: 'Enter a new password to change it, or leave this field blank to keep the current password.',
      passwordHelpLabel: 'Password requirements',
      forceChange: 'Force change password on next login',
      notes: 'Notes',
      notesPlaceholder: 'Enter notes',
      organisation: 'Organisation',
      customerPortalRole: 'Customer Portal role',
      assignedKnowledgeBases: 'Assigned knowledge bases',
      checkingEmail: 'Checking email...',
      emailCheckFailed: 'Email could not be checked. Please try again.',
      loadFailed: 'User details could not be loaded.',
      organisationLoadFailed: 'Organisation knowledge bases could not be loaded.',
      multiTitle: 'CEADE handling required',
      multiBody: 'This user belongs to more than one organisation. You can update Assigned knowledge bases and Customer Portal role for {{organisation}} only. Please contact CEADE to change profile details, reset the password, or delete this user.',
      duplicateTitle: 'CEADE handling required',
      duplicateBody: "Looks like this email address is already registered in SnapInsight. Please email the CEADE team and they'll help you add this user to your organisation.",
    },
  },
  creditDashboard: {
    heading: 'Credit dashboard',
    allowance: 'Credit allowance',
    consumed: 'Credits consumed',
    remaining: 'Credits remaining',
    consumption: 'Credit Consumption',
    questionsSeries: 'Questions',
    creditsSeries: 'Credits consumed',
    exportFailed: 'Unable to download data. Please try again.',
  },
};

export default translations;
